import { Pipe, PipeTransform } from '@angular/core';
import { Directory } from '@capacitor/filesystem';
import { Observable, catchError, defer, forkJoin, map, of } from 'rxjs';
import { FileService } from 'src/app/services/app/file.service';
import { App_ImagesSources } from 'src/app/utils/interfaces';
import { extractExtensionFromWeb, extToMimeType } from 'src/app/utils/utils';

function escapeRegExp(text: string): string {
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

@Pipe({
  name: 'fetchImageFromHtmlPipe'
})
export class FetchImageFromHtmlPipe implements PipeTransform {

  constructor(
    private fileService: FileService,
    // em: embed
  ) { }

  transform(html: string | null | undefined, images: App_ImagesSources[] | undefined): Observable<string> {
    const safeHtml = html ?? '';
    if (Array.isArray(images) && images.length > 0) {
      const imgsInHtmlTemplates = images.filter(image =>
        new RegExp(`src=["']${escapeRegExp(image.identifier)}["']`).test(safeHtml)
      );
      if (imgsInHtmlTemplates.length > 0) {
        const fetchLocally = (image: App_ImagesSources) => defer(() => this.fileService.readFile(image.identifier, Directory.Data)).pipe(
          map(readfileResult => readfileResult.data as string),
          map(srcReplace => {
            const type = extToMimeType(extractExtensionFromWeb(image.web));
            return `data:${type};base64,${srcReplace}`
          }),
          map(srcReplace => ({image, srcReplace}))
        );
        return forkJoin(imgsInHtmlTemplates.map(image => fetchLocally(image).pipe(
          catchError(err => of({image, srcReplace: image.web}))
        ))).pipe(
          map(results => {
            return results.reduce((newHtml, result) => {
              const esc = escapeRegExp(result.image.identifier);
              const withDouble = newHtml.replace(new RegExp(`src="${esc}"`, 'g'), `src="${result.srcReplace}"`);
              return withDouble.replace(new RegExp(`src='${esc}'`, 'g'), `src="${result.srcReplace}"`);
            }, safeHtml);
          })
        );
      }
    }
    return of(safeHtml);
  }

}
